import { useContext } from "react";

import { MeContext } from "../context/MeContext";

export function useAuth() {
  return useContext(MeContext);
}
